import { useState, useEffect } from "react"
import { useUpdateCategoryMutation, useDeleteCategoryMutation } from "./categoriesApiSlice"
import { useNavigate } from "react-router-dom"
import useAuth from "../../hooks/useAuth"
import useLang from '../../hooks/useLang'
import useTranslate from '../../hooks/useTranslate'

// import `ChakraProvider` component
import { Box, Grid, GridItem, Center, HStack, Container, Input, Select, Switch, Button, IconButton, Text, useToast } from '@chakra-ui/react'
import { FormControl, FormLabel } from "@chakra-ui/react"

// import `ChakraProvider` icon
import { ArrowBackIcon, CheckIcon, CloseIcon, AddIcon, MinusIcon } from '@chakra-ui/icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolderTree } from "@fortawesome/free-solid-svg-icons"

const EditCategoryForm = ({ category, parents }) => {

    const { isManager, isAdmin } = useAuth()

    const { lang } = useLang()
    const { T } = useTranslate(lang)

    const [updateCategory, {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateCategoryMutation()

    const [deleteCategory, {
        data: delData,
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delError
    }] = useDeleteCategoryMutation()

    const navigate = useNavigate()

    let [canSave, setCanSave] = useState(false)

    const [categoryStatus, setCategoryStatus] = useState(category.categoryStatus)
    const [parentId, setParentId] = useState(category.parentId)

    const toastInfo = useToast({
        position: 'bottom-left',
        variant: 'left-accent',
    })

    const checkCanSave = () => {
        {
            setCanSave(true)
            if ((parentId == '')) {
                setCanSave(false)
            }
            formFieldsCategoryName.map((form) => {
                if (!isLoading && (form.lang == '' || form.categoryName == '')) {
                    setCanSave(false)
                }
            })
        }
    }

    const onPageBack = () => navigate('/dash/categories')

    const onParentIdChanged = e => setParentId(e.target.value)
    const onCategoryStatusChanged = e => setCategoryStatus(prev => !prev)

    const onSaveCategoryClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            let output = []
            let categoryNameByLang = {}
            formFieldsCategoryName.forEach(field => {
                categoryNameByLang[field.lang] = field.categoryName
            })
            output['categoryName'] = categoryNameByLang
            console.log(output)

            await updateCategory({ id: category.id, parentId: parentId, categoryName: categoryNameByLang, categoryStatus })
        }
    }

    const onDeleteCategoryClicked = async () => {
        await deleteCategory({ id: category.id })
    }

    const created = new Date(category.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    const updated = new Date(category.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })

    console.log('parents = ' + JSON.stringify(parents))
    const options = parents.map(parent => {
        return (
            <option
                key={parent.id}
                value={parent.id}
            > {parent.categoryName[lang]}</option >
        )
    })

    let deleteButton = null
    if (isManager || isAdmin) {
        deleteButton = (
            <Button size='xs' onClick={onDeleteCategoryClicked} name="Delete" title={T.common.Delete} leftIcon={<CloseIcon />} colorScheme='red' variant='outline'>{T.categories.DeleteThisCategory}</Button>
        )
    }

    const initCategoryNamesForm = () => {
        let categoryNameByLang = []
        Object.entries(category.categoryName).map(item => {
            categoryNameByLang.push({ lang: item[0], categoryName: item[1] })
        })
        return categoryNameByLang
    }

    const [formFieldsCategoryName, setFormFields] = useState(initCategoryNamesForm)

    const handleFormChange = (event, index) => {
        let data = [...formFieldsCategoryName];
        data[index][event.target.name] = event.target.value;
        setFormFields(data);
        checkCanSave()
    }

    const addFields = () => {
        let object = {
            lang: '',
            categoryName: ''
        }
        setFormFields([...formFieldsCategoryName, object])
        setCanSave(false)
    }

    const removeFields = (index) => {
        let data = [...formFieldsCategoryName];
        data.splice(index, 1)
        setFormFields(data)
        checkCanSave()
    }

    useEffect(() => {
        checkCanSave()
        if (isSuccess) {
            toastInfo({ title: 'CATEGORY : ' + data?.message + ' successfully', status: 'success' })
            initCategoryNamesForm()
            setParentId('')
            navigate('/dash/categories')
        }
        if (isError) {
            toastInfo({ title: 'CATEGORY : Update error (' + error?.data?.message + ')', status: 'error' })
        }
        if (isDelSuccess) {
            toastInfo({ title: 'CATEGORY : ' + delData?.message + ' successfully', status: 'success' })
            initCategoryNamesForm()
            navigate('/dash/categories')
        }
        if (isDelError) {
            toastInfo({ title: 'CATEGORY : Update error (' + delError?.data?.message + ')', status: 'error' })
        }
    }, [checkCanSave, initCategoryNamesForm, toastInfo, isError, error, isDelError, delError, isSuccess, isDelSuccess, navigate])

    const content = (
        <>
            <Center bg='#45413C' p='0' color='white' axis='both'>
                <Grid w='95vw' maxW='1500' minH='100vh' gap={5} p='5' templateColumns='repeat(12, 1fr)'>
                    <GridItem color='black' colSpan={{ base: "12", sm: "12", md: "12", lg: "12", xl: "12" }}>
                        <HStack color='white'>
                            <Container color='262626' textAlign={['left']} >
                                <Text fontSize={{ base: "24", sm: "24", md: "24", lg: "24", xl: "28" }} fontWeight={600}><FontAwesomeIcon icon={faFolderTree} /> {T.categories.EditCategory}</Text><br />
                            </Container>
                            <Container color='262626' textAlign={['right']}>
                                <Button size='sm' onClick={onPageBack} leftIcon={<ArrowBackIcon />} colorScheme='gray' variant='solid' mr='2'>
                                    <Text display={{ base: 'none', sm: 'flex' }} fontSize={{ base: "18", sm: "18", md: "18", lg: "18", xl: "20" }} fontWeight={600}>{T.common.Back}</Text>
                                </Button>
                                <Button
                                    size='sm'
                                    onClick={onSaveCategoryClicked}
                                    disabled={!canSave}
                                    leftIcon={<CheckIcon />}
                                    colorScheme={canSave ? "teal" : "gray"}
                                >
                                    <Text display={{ base: 'none', sm: 'flex' }} fontSize={{ base: "18", sm: "18", md: "18", lg: "18", xl: "20" }} fontWeight={600}>{T.common.Save}</Text>
                                </Button>
                            </Container>
                        </HStack>
                        <Box borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' borderColor='black' bg='white' w="100%">

                            <form onSubmit={e => e.preventDefault()}>
                                <FormControl>

                                    <FormLabel htmlFor='countryTranslate' mt='5' mb='0'>
                                        {T.categories.CategoryName}
                                    </FormLabel>
                                    {formFieldsCategoryName.map((form, index) => {
                                        return (
                                            <HStack key={index}>
                                                <Input
                                                    isInvalid={!form.lang}
                                                    name='lang'
                                                    placeholder={T.categories.IsoCode}
                                                    onChange={event => handleFormChange(event, index)}
                                                    value={form.lang}
                                                    focusBorderColor='blue.400'
                                                    errorBorderColor='red.300'
                                                    minLength="2"
                                                    maxLength="2"
                                                    bg='yellow.100'
                                                    w='10vw'
                                                />
                                                <Input
                                                    isInvalid={!form.categoryName}
                                                    name='categoryName'
                                                    placeholder={T.categories.TranslatedName}
                                                    onChange={event => handleFormChange(event, index)}
                                                    value={form.categoryName}
                                                    focusBorderColor='blue.400'
                                                    errorBorderColor='red.300'
                                                    bg='yellow.100'
                                                    w='50vw'
                                                />
                                                {index !== 0 &&
                                                    <IconButton
                                                        size='xs'
                                                        name="Remove"
                                                        title={T.common.Delete}
                                                        colorScheme='gray'
                                                        aria-label={T.common.Delete}
                                                        icon={<MinusIcon />}
                                                        onClick={() => removeFields(index)}
                                                    />
                                                }
                                            </HStack>
                                        )
                                    })
                                    }
                                    <IconButton
                                        size='xs'
                                        title={T.common.Add}
                                        onClick={addFields}
                                        colorScheme='gray'
                                        aria-label={T.common.Add}
                                        icon={<AddIcon />}
                                    />

                                    <FormLabel htmlFor='parentId' mt='5' mb='0'>
                                        {T.categories.CategoryParent}
                                    </FormLabel>
                                    <Select
                                        id="parentId"
                                        name="parentId"
                                        className="form__select"
                                        value={parentId}
                                        onChange={onParentIdChanged}
                                        bg='yellow.100'
                                    >
                                        {options}
                                    </Select>

                                    <FormLabel htmlFor='categoryStatus' mt='5' mb='0'>
                                        {T.categories.Status}
                                    </FormLabel>
                                    <Switch
                                        id='categoryStatus'
                                        name="status"
                                        colorScheme='green'
                                        isChecked={categoryStatus}
                                        onChange={onCategoryStatusChanged}
                                    />

                                </FormControl>
                                <br />

                                <HStack>
                                    <Text fontSize={{ base: "10", sm: "10", md: "10", lg: "15", xl: "15" }} fontWeight={600}>{T.common.Created}:</Text>
                                    <Text fontSize={{ base: "10", sm: "10", md: "10", lg: "15", xl: "15" }}>{created}</Text>
                                </HStack>
                                <HStack>
                                    <Text fontSize={{ base: "10", sm: "10", md: "10", lg: "15", xl: "15" }} fontWeight={600}>{T.common.Updated}:</Text>
                                    <Text fontSize={{ base: "10", sm: "10", md: "10", lg: "15", xl: "15" }}>{updated}</Text>
                                </HStack>
                            </form>

                            <br />
                            <br />
                            {deleteButton}

                        </Box>
                    </GridItem>

                </Grid>
            </Center>

        </>
    )

    return content
}

export default EditCategoryForm